export const OS: any = 'web';
export const Platform = { OS };

const initialWindowMetrics: any = false;
const StatusBar: any = {};
const RNInfoManifestBridge: any = null;

export default {
  OS,
  Platform,
  StatusBar,
  initialWindowMetrics,
  RNInfoManifestBridge,
};
